// extracted by mini-css-extract-plugin
module.exports = {"content":"Content-module--content--1tfQQ","content__title":"Content-module--content__title--1qFLI","content__body":"Content-module--content__body--2bfha"};